import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { useBalanceSheetData } from "./hooks/useBalanceSheetData";
import { BalanceSheetActions } from "./Components/BalanceSheetActions";
import { BalanceSheetFilters } from "./Components/BalanceSheetFilters";
import { BalanceSheetTable } from "./Components/BalanceSheetTable";

export default function BalanceSheet() {
  const { texts } = useLang();
  const {
    applyFilters,
    branches,
    changeCurrency,
    costCenters,
    exportReport,
    filters,
    isExporting,
    isLoadingReport,
    loadFilterOptions,
    projects,
    reportData,
    toggleRow,
  } = useBalanceSheetData();

  return (
    <Box height={'calc(100dvh - 3rem)'} display={'flex'} flexDirection={'column'}>
      <Flex {...reportToolbarStyles.headerRow} flexShrink={0}>
        <ReportHeader
          title={texts.reports?.balanceSheet || "Balance Sheet"}
          subtitle={texts.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar>
          <BalanceSheetFilters
            branches={branches}
            costCenters={costCenters}
            currentFilters={filters}
            loadFilterOptions={loadFilterOptions}
            onApplyFilters={applyFilters}
            onCurrencyChange={changeCurrency}
            projects={projects}
          />
          <BalanceSheetActions isExporting={isExporting} onExport={exportReport} />
        </ReportToolbar>
      </Flex>
      <BalanceSheetTable data={reportData} isLoading={isLoadingReport} onToggleRow={toggleRow} />
    </Box>
  );
}
